<template>
  <rent-orderr-item
    :orderrItemGroup="orderrItemGroup"
    :product="rentSetItemDto.product"
    :orderrItem="rentSetItemDto.orderrItem"
    @change="orderrItemChange"
  >
  </rent-orderr-item>

</template>

<script>

import RentOrderrItem from "@/components/RentOrderrItem";

export default {
  
  name: "RentSetOrderrItem",

  components: {
    RentOrderrItem
  },

  props: {
    rentSetItemDto: {
      type: Object,
      required: true,
    },

    orderrItemGroup: {
      type: Object,
      required: true,
    },
  },

  methods: {
    orderrItemChange: function(oi) {
      this.$emit("change", oi);
    }
  }
}
</script>

<style>

</style>